<template>
  <div class="app-object-organization">

    <input-title :required="options.required" :description="options.description"/>

    <div
      v-if="organizations"
      class="input-groups">
      <el-checkbox
        v-if = "options.showAgreement && options.descriptionforced"
        @change="agreementNotAccepted = false"
        v-model="organizationAgreement">
        <div class="organization-agreement">
          {{ options.descriptionforced }}
        </div>
        <div v-if="agreementNotAccepted" class="ait_message ait_message--error">
          Необходимо принять условия депонирования
        </div>
      </el-checkbox>
      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group">
        <el-select
          :disabled="!organizationAgreement"
          v-model="valueLocal[i].OrganizationId"
          :key="'input-' + i"
          :class="{ 'child-has-error': error[i].emptyOrganization }"
          clearable
          @change="onChange(i)"
          @focus="clearError('emptyOrganization', i)"
          v-bind="widgetOptions">
          <el-option
            v-for="(o, j) in organizations"
            :key="'option-' + j"
            :label="o.Organization"
            :value="o.OrganizationId">
          </el-option>
        </el-select>
        <div v-if="error[i].emptyOrganization" class="ait_message ait_message--error">
          {{ error[i].emptyOrganization }}
        </div>
        <template v-if="valueLocal[i].OrganizationId === 'other'">
          <div class="input-subtitle input-organization-name">
            Название организации</div>
          <el-input
            v-model="valueLocal[i].Organization"
            :disabled="!organizationAgreement"
            @focus="clearError('extOrganization', i)"
            :class="{ 'child-has-error': error[i].extOrganization }"
            :key="`organization-${i}`"/>
        </template>
        <div v-if="error[i].extOrganization" class="ait_message ait_message--error">
          {{ error[i].extOrganization }}
        </div>
        <el-checkbox
          :disabled="!organizationAgreement"
          v-model="valueLocal[i].IsCopyrightHolder"
          class="copyright-holder">
          Является правообладателем (в соответствии с ч. IV ГК РФ)
        </el-checkbox>
      </div>

    </div>
    <template
        v-if="organizationAgreement">
      <add-rem-btns/>
    </template>

  </div>
</template>

<script>
import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        OrganizationId: '',
        Organization: '',
        IsCopyrightHolder: true,
      },
      errorBase: { emptyOrganization: '', extOrganization: '' },
      organizations: [],
      organizationAgreement: '',
      agreementNotAccepted: false,
    };
  },

  created() {
    this.error.push(this.errorBase);
    this.validateMessages = Object.assign(
      this.validateMessages, {
        emptyOrganization: 'Выберите организацию',
        extOrganization: 'Заполните название организации',
      },
    );
    if (this.options.showAgreement && this.options.descriptionforced) {
      this.organizationAgreement = false;
    } else {
      this.organizationAgreement = true;
    }
    // Process local options for this widget type
    this.widgetOptions.placeholder = this.options.placeholder ?
      this.options.placeholder : 'Выберите организацию...';
    // Get organizations
    axios.get('organizations').then((response) => {
      response.data.forEach((el) => {
        this.organizations.push({
          Organization: el.ShortName,
          OrganizationId: el.OrganizationId,
        });
      });
      this.organizations.unshift({
        Organization: 'Другая организация',
        OrganizationId: 'other',
      });
    });
    if (!this.options.EditMode
      && this.options.defaultvalue
      && this.options.defaultvalue.length !== 0) {
      this.setValue(this.options.defaultvalue);
    }
  },

  methods: {

    onChange(index) {
      this.valueLocal[index].Organization = '';
    },

    setValue(value) {
      this.valueLocal = [];
      if (value.length) {
        if (this.options.EditMode) this.organizationAgreement = true;
        value.forEach((v, i) => {
          this.error[i] = this.errorBase;
          this.valueLocal.push({
            OrganizationId: v.OrganizationId ? v.OrganizationId : 'other',
            Organization: v.Organization ? v.Organization : '',
            IsCopyrightHolder:
              typeof v.IsCopyrightHolder === 'undefined'
                || v.IsCopyrightHolder !== false
                ? true : v.IsCopyrightHolder,
          });
        });
      } else { this.valueLocal.push(''); }
      this.$forceUpdate();
    },

    getValue() {
      const result = [];
      this.valueLocal.forEach((value, i) => {
        result[i] = {
          Organization: value.OrganizationId === 'other' ? value.Organization : '',
          OrganizationId: value.OrganizationId !== 'other' ? value.OrganizationId : '',
          IsCopyrightHolder: value.IsCopyrightHolder,
        };
      });
      return result;
    },

    getError() {
      // Validate if required
      if (this.options.required) {
        if (!this.organizationAgreement) {
          this.agreementNotAccepted = true;
        }
        this.valueLocal.forEach((el, i) => {
          this.error[i] = { emptyOrganization: '', extOrganization: '' };
          if (el.OrganizationId === 'other') {
            if (el.Organization === '') {
              this.error[i].extOrganization = this.validateMessages.extOrganization;
            }
          } else if (!el.OrganizationId) {
            this.error[i].emptyOrganization = this.validateMessages.emptyOrganization;
          }
        });
      }
      this.updateValue();
      return this.error;
    },

    clearError(elName, i) {
      if (this.error[i][elName]) {
        this.error[i][elName] = '';
        this.$forceUpdate();
      }
    },

  },

};
</script>

<style lang="scss">
.app-object-organization {
  .el-input.is-disabled .el-input__inner {
    background: rgba(0, 0, 0, 0.1);
  }
  .el-checkbox {
    span {
      vertical-align: top;
    }
  }
  .organization-agreement {
    color: #ededed;
    white-space: normal;
    margin-bottom: 30px;
  }
  .input-group {
    border-bottom: 1px dotted rgba(255, 255, 255, .3);
    padding-bottom: 32px;
    &:last-of-type {
      border-bottom: none!important;
      padding-bottom: 20px;
    }
    .input-organization-name {
      margin-top: 15px;
    }
  }
  .copyright-holder {
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppObjectOrganization.vue